import { render, staticRenderFns } from "./customerData_ec.vue?vue&type=template&id=35b3a342&scoped=true&"
import script from "./customerData_ec.vue?vue&type=script&lang=js&"
export * from "./customerData_ec.vue?vue&type=script&lang=js&"
import style0 from "./customerData_ec.vue?vue&type=style&index=0&id=35b3a342&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3a342",
  null
  
)

component.options.__file = "customerData_ec.vue"
export default component.exports